<template>
  <el-drawer
    title="抄送"
    :visible.sync="drawer"
    :before-close="hanldeDrawerClose"
  >
    <div class="copy-container">
      <div class="upload-label" style="text-align: left; padding-bottom: 20px;">
        请选择抄送人：
      </div>
      <div class="copy-content">
        <el-select
          v-model="viewers"
          multiple
          placeholder="请选择"
          collapse-tags
          filterable
        >
          <el-option
            v-for="item in viewersList"
            :key="item.open_id"
            :label="item.name"
            :value="item.open_id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="upload-label" style="text-align: left; padding-bottom: 20px;">
        请输入抄送原因：
      </div>
      <div class="copy-content">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入"
          v-model="reason"
        >
        </el-input>
      </div>

      <el-button type="primary" @click="handleCopy" :loading="commantLoading">
        抄送</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
import { getNologinUsers } from '@/api/base';
import { copyToPerson } from '@/api/approval';
export default {
  name: 'copyDrawer',
  mounted() {
    this.$on('openDrawer', () => {
      this.drawer = true;
      this.initCompanyList();
    });
  },
  data() {
    return {
      commantLoading: false,
      drawer: false,
      viewers: [],
      reason: '',
      viewersList: [],
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  methods: {
    hanldeDrawerClose(){
      this.viewers = [];
      this.reason = '';
      this.drawer = false;
    },
    initCompanyList() {
      getNologinUsers().then((res) => {
        console.log(res);
        this.viewersList = res.data;
      });
    },
    handleCopy() {
      if (this.viewers.length <= 0) {
        this.$message.warning('请选择抄送人');
        return;
      }
      this.commantLoading = true;
      console.log(this.viewers);
      copyToPerson(this.id, this.reason, this.viewers)
        .then((res) => {
          this.$emit('refreshIns');
          if (res.code != 0) {
            return this.$message.error(res.message);
          }
          this.drawer = false;
          this.viewers = [];
          this.reason = '';
          this.$message.success('抄送成功');
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.commantLoading = false;
        });
    },
  },
  hanldeDrawerClose() {
    this.drawer = false;
  },
};
</script>

<style lang="scss" scoped>
.copy-container {
  //   text-align: center;
  padding: 0 20px;

  .copy-content {
    margin-bottom: 20px;
  }

  .el-button {
    padding: 10px 30px;
  }
}
</style>